import script from "./AnnouncementDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementDetail.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementDetail.vue?vue&type=style&index=0&id=bbbdffb0&lang=css"
import "./AnnouncementDetail.vue?vue&type=style&index=1&id=bbbdffb0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbbdffb0"]])

export default __exports__